/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum HarvestSex {
  Male = 'MALE',
  Female = 'FEMALE',
  AsHatched = 'AS_HATCHED'
}
